import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

export const Counter = (props: {
    number: string | number;
    componentClasses?: string;
    onClick?: (e) => void;
}) => {
    return (
        <div className={cx(styles.component, props.componentClasses)} onClick={props.onClick}>
            {props.number}
        </div>
    );
};
